import type { FaireProductEntity } from "../../entity_types/product";

export const p_q9dkbwhkhs: FaireProductEntity = {
  token: "p_q9dkbwhkhs",
  type: "product",
  name: "STILL UP? christmas card",
  brandToken: "b_d5lao1dk",
  brandName: "offensivedelightful",
  imageUrl:
    "https://cdn.faire.com/fastly/14ff48f715695c1f7a4720aa6b8bbd30e5d54332f9c03ec75e17291008b9caf3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8ffc3a02de6950100140fd080cdd1fe1bcd3d7750308be7d0a1de249e4aaf72.png",
    "https://cdn.faire.com/fastly/ab1229add2534c5e85e533a3759c64003cc660b1ba3246ee0506b86d5d855049.jpeg",
    "https://cdn.faire.com/fastly/0f165b5b137bd3ca463c3a24ba23237d13f253411190e70e89bde3a7638dca27.png",
  ],
  priceDollars: 2.85,
  description:
    '"You Still Up?" Style No. MX.14 holiday greeting card, funny, christmas, funny holiday card. This is the one card that everyone wants. Best sellers 3 years in a row.\n',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:28.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
